<template>
  <van-popup v-model="showBind" class="backRect" @closed="onClosed">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <div class="inputRect">

      <van-field
        v-for="(item,index) in emails"
        :key="index"
        v-model="emails[index]"
        clearable
        :label="'电子邮箱'+(index+1)"
        placeholder="请输入用户电子邮箱"
        @blur="onEmailBlur"
      />

      <div class="buttonRect">
        <van-button type="primary" size="large" loading-text="正在添加中,请耐心等待" :loading="buttonLoading" :color="GetColorMain()" @click="onAddClassStudent">添加学员</van-button>
      </div>
    </div>
    <div class="regAbout">
      请务必保证电子邮箱正确无误,一旦提交无法修改,只能重新注册!
    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Popup, Field, Toast, Dialog } from 'vant'
import { isEmptyStr, formatDate, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    TopBar
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
    // eslint-disable-next-line
    showType:undefined
  },
  data() {
    return {
      title: '注册学员',
      classId: undefined,
      showBind: false,
      buttonLoading: false,
      postData: {
        classId: undefined,
        emails: ['']
      },
      emails: ['']
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.postData.classId = newValue
        this.showBind = true
      } else {
        this.postData.classId = undefined
        this.showBind = false
      }
    }
  },
  created() {

  },
  methods: {
    isEmptyStr,
    formatDate,
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onEmailBlur() {
      var allFull = true
      this.emails.forEach(item => {
        if (isEmptyStr(item)) {
          allFull = false
        }
      })
      if (allFull) {
        this.emails.push('')
      }
    },
    onAddClassStudent() {
      var message = '确认添加以下学员:\n'
      this.postData.emails = []
      this.emails.forEach(item => {
        if (!isEmptyStr(item)) {
          this.postData.emails.push(item)
          message += item + '\n'
        }
      })
      if (this.postData.emails.length <= 0) {
        MyNotify('info', '请至少输入一个电子邮箱')
        return
      }
      message += '请仔细核对邮箱是否正确，一旦提交无法撤销!'
      Dialog.confirm({
        title: '添加班级学员',
        message: message
      })
        .then(() => {
          this.onAddClassStudentDo()
        })
    },
    onAddClassStudentDo() {
      this.buttonLoading = true
      request({
        url: '/Pro/addClassStudentAida',
        method: 'post',
        data: this.postData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.showBind = false
        this.$emit('reload')
      })
    }

  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
</style>
